import { TransactionSearchComponent } from './../../transaction/transaction-search/transaction-search.component';
import { Subscription } from 'rxjs';
import { ManualCorrectionComponent } from './../../correction/manual-correction/manual-correction.component';
import { AppConfig } from './../../app.config';
import { SurvivalHorizonService } from './../../survival-horizon/survival-horizon.service';
import { DashboardEventService } from '../../dashboard/dashboard-event.service';
import { BucketingStrategy } from '../../bucket/bucketing-strategy';
import { Component, Input, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { MatButtonToggleChange, } from '@angular/material/button-toggle';
import { MatDialog } from '@angular/material/dialog';
import { Correction, CORRECTION_TYPES } from '@liquitics/transaction';

import { SwitchDateComponent } from '../../profile/switch-date/switch-date.component';

export enum LadderViewMode {
    DATATABLE,
    CHART
}
enum LadderBucketingMode {
    SURVIVIAL_HORIZON,
    OTHER
}

@Component({
    selector: 'app-home-sidebar-sh',
    templateUrl: './sidebar-sh.component.html',
    styleUrls: ['./../home.sidebar.component.scss']
})
export class SidebarSHComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input()
    profileType: string;
    strategies: BucketingChoice[];
    selectedStrategy: BucketingStrategy;

    LadderViewMode: typeof LadderViewMode = LadderViewMode;
    ladderViewMode: LadderViewMode = LadderViewMode.DATATABLE;

    LadderBucketingMode: typeof LadderBucketingMode = LadderBucketingMode;
    ladderBucketingMode: LadderBucketingMode = LadderBucketingMode.SURVIVIAL_HORIZON;

    survivalHorizonViewMode = 'live';

    subscription: Subscription;

    constructor(
        // @Inject(forwardRef(() => HomeComponent)) public app: HomeComponent,
        private survivalHorizonService: SurvivalHorizonService,
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig,
        private dialog: MatDialog) {
    }

    ngOnInit() {
        this.initializeSideBar();
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }

    }

    ngAfterViewInit() {

    }

    initializeSideBar() {
        this.strategies = [];
        this.strategies.push(...this.survivalHorizonService.getBucketingStrategies().map((bucketingStrategy: BucketingStrategy) => {
            return new BucketingChoice(bucketingStrategy);
        }));
        this.selectedStrategy = this.strategies[0].bucketingStrategy;
        // Trigger this on delay so we make sure that the components first get initialized and ready to receive the event
        // setTimeout(() => {
        this.dashboardEventService.survivalHorizonModeSubject.next('live');
        this.dashboardEventService.ladderBucketingStrategySubject.next(this.selectedStrategy);
        // }, 50);
    }

    onLadderViewModeChange(event: MatButtonToggleChange) {
        this.dashboardEventService.ladderViewModeSubject.next(event.value);
        // this.app.closeSidebar(undefined);
    }

    onStrategySelected(selected: BucketingChoice) {
        this.selectedStrategy = selected.bucketingStrategy;
        this.dashboardEventService.ladderBucketingStrategySubject.next(this.selectedStrategy);
        // this.app.closeSidebar(undefined);
    }

    onSurvivalHorizonViewModeChange(event: MatButtonToggleChange) {
        this.dashboardEventService.survivalHorizonModeSubject.next(event.value);
        this.dashboardEventService.ladderBucketingStrategySubject.next(this.selectedStrategy);
        // this.app.closeSidebar(undefined);
    }

    isSelectedStrategy(strategy: BucketingStrategy) {
        if (!this.selectedStrategy || !strategy) {
            return false;
        }
        return this.selectedStrategy.strategyName() === strategy.strategyName();
    }

    openManualCorrectionDialog() {
        const correction = {} as Correction;
        correction.type = CORRECTION_TYPES.MANUAL_CORRECTION;
        correction.settleDate = undefined;
        correction.direction = '';
        correction.currency = '';
        correction.amount = 0;
        correction.desk = '';
        correction.changeReason = '';

        const dialogRef = this.dialog.open(ManualCorrectionComponent, {
            width: '50%',
            data: {
                correction: correction
            }
        });

        // dialogRef.afterClosed().subscribe({next: result => {
        //     console.log('The dialog was closed');
        // });
    }

    openAsOfDateDialog() {
        const dialogRef = this.dialog.open(SwitchDateComponent, {
            // width: '20%',
            data: {
            }
        });
    }

    openTransactionSearchDialog() {
        const dialogRef = this.dialog.open(TransactionSearchComponent, {
            width: '80%',
            height: '80%',
            data: {
            }
        });
    }
}

export class BucketingChoice {
    displayName: string;
    bucketingStrategy: BucketingStrategy;

    constructor(bs: BucketingStrategy) {
        this.bucketingStrategy = bs;
        this.displayName = bs.strategyName();
    }
}
